<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.iqc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="iqc_vendname">
            <label class="weui-form-preview__label">{{customLabel.iqc_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.iqc_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="iqc_pucode">
            <label class="weui-form-preview__label">{{customLabel.iqc_pucode || "采购单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_pucode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqc_vacode">
            <label class="weui-form-preview__label">{{customLabel.iqc_vacode || "收料单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_vacode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqc_qty">
            <label class="weui-form-preview__label">{{customLabel.iqc_qty || "收料数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.iqc_qty }} {{ form.main.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="iqc_prodcode">
            <label class="weui-form-preview__label">{{customLabel.iqc_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" >
        <div class="weui-panel__hd">检验标准</div>
        <custom-layout :view-config="customViewConfig" class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item" slot="iqc_type">
            <label class="weui-form-preview__label">{{customLabel.iqc_type || "检验类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_type
            }}</span>
          </div>
          <div slot="iqc_sample"
            class="weui-form-preview__item"
            v-if="form.main.iqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_sample || "抽样标准"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_sample
            }}</span>
          </div>
          <div slot="iqc_sample_std_qty"
            class="weui-form-preview__item"
            v-if="form.main.iqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_sample_std_qty || "标准抽样数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_sample_std_qty
            }}</span>
          </div>
          <div slot="iqc_aql"
            class="weui-form-preview__item"
            v-if="form.main.iqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_aql || "AQL标准"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_aql
            }}</span>
          </div>
          <div slot="iqc_aql_ng_max"
            class="weui-form-preview__item"
            v-if="form.main.iqc_type == '抽检'"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_aql_ng_max || "最大不合格允收数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_aql_ng_max
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.main.iqc_type == '抽检'" >
        <div class="weui-panel__hd">抽样结果</div>
        <custom-layout :view-config="customViewConfig" class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item" slot="iqc_sample_qty">
            <label class="weui-form-preview__label">{{customLabel.iqc_sample_qty || "抽样数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_sample_qty
            }}</span>
          </div>
          <div slot="iqc_sample_ok_qty"
            class="weui-form-preview__item"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_sample_ok_qty || "抽样合格数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_sample_ok_qty
            }}</span>
          </div>
          <div slot="iqc_sample_ng_qty"
            class="weui-form-preview__item"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_sample_ng_qty || "抽样不合格数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_sample_ng_qty
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" >
        <div class="weui-panel__hd">判定结果</div>
        <custom-layout :view-config="customViewConfig" class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item" slot="iqc_result">
            <label class="weui-form-preview__label">{{customLabel.iqc_result || "判定结果"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqc_okqty">
            <label class="weui-form-preview__label">{{customLabel.iqc_okqty || "合格数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_okqty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqc_ngqty">
            <label class="weui-form-preview__label">{{customLabel.iqc_ngqty || "不合格数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_ngqty
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.id_ng_level" slot="id_ng_level">
            <label class="weui-form-preview__label">{{customLabel.id_ng_level || "缺陷等级"}}</label>
            <span class="weui-form-preview__value">{{
              getNgDesc(form.main.id_ng_level)
            }}</span>
          </div>
          <div slot="iqc_ng_desc"
            class="weui-form-preview__item"
            v-if="form.main.iqc_ng_desc"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_ng_desc || "不合格描述"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_ng_desc
            }}</span>
          </div>
          <div slot="iqc_ng_reason"
            class="weui-form-preview__item"
            v-if="form.main.iqc_ng_reason"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_ng_reason || "不良原因"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_ng_reason
            }}</span>
          </div>
          <div slot="iqc_ng_handle"
            class="weui-form-preview__item"
            v-if="form.main.iqc_ng_handle"
          >
            <label class="weui-form-preview__label">{{customLabel.iqc_ng_handle || "不良处理"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iqc_ng_handle
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="footer-bar weui-dialog__ft">
        <share class="weui-dialog__btn weui-dialog__btn_default" v-if="!editable" :biz-data="bizData"></share>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Share from "@/components/button/Share.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Share
  },
  data() {
    return {
      baseUrl: "/api/storage/purciqc",
      caller: "PurcIqc",
      xtype: "stock-purcIqc-formpanel",
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.iqc_code,
        bizType: "PurcIqc",
        bizId: main.id,
        viewType: "stock-purcIqc-formpanel",
        title: "IQC检验单" + main.iqc_code,
      };
    },
  },
  methods: {
    getNgDesc(level) {
      if (level <= 4) {
        return ["无缺陷", "致命缺陷", "严重缺陷", "一般缺陷", "轻微缺陷"][
          level
        ];
      }
      return null;
    },
  },
};
</script>